<template>
  <div class="text-center my-4" data-cy="noCreditResultsFound">
    <div class="primary-fill-svg img">
      <inline-svg :src="require('@/assets/error-credit.svg')" />
    </div>
    <h2 data-test="heading" class="mt-4">{{ $t('message.credit.noCreditFound.heading') }}</h2>
    <p data-test="msg">{{ $t('message.credit.noCreditFound.msg', { dealershipName }) }}</p>
  </div>
</template>

<script>
export default {
  name: 'CreditResultsNoResults',
  data() {
    return {};
  },
  props: {
    dealershipName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 575px) {
  .img svg {
    width: 55px;
    height: 43px;
  }
}
p {
  max-width: 475px;
  margin: 0 auto;
}
</style>
